import { createObjectSchema, createStringSchema } from '@dreryk/react-draft';

import { referralCommonDraftSchema } from '../referral.draft';
import { icd9ProcedureSchema } from '../shared/Icd9ProcedureField/Icd9ProcedureField.draft';
import { healthcareFacilityLocationSpecialtySchema } from '../shared/HealthcareFacilitySpecialtyField/HealthcareFacilityLocationSpecialty.draft';

import { ReferralToSpecialistFormBean } from './ReferralToSpecialistForm/ReferralToSpecialistForm.types';

export const referralToSpecialistDraftSchema = createObjectSchema<ReferralToSpecialistFormBean>({
   unitNameAndAddress: createStringSchema().nullable(),
   objective: createStringSchema().nullable(),
   illnessesAlreadyPassed: createStringSchema().nullable(),
   examinationsAlreadyPerformed: createStringSchema().nullable(),
   additionalInformation: createStringSchema().nullable(),
   icd9Procedures: icd9ProcedureSchema.array(),
})
   .merge(referralCommonDraftSchema)
   .merge(healthcareFacilityLocationSpecialtySchema)
   .strict();
